// Centralized data for the Ezhil Biomedical website

export const COMPANY = {
    name: "Ezhil Biomedical",
    fullName: "Ezhil Biomedical Sales and Services",
    tagline: "Trusted Medical Equipment Solutions for Modern Healthcare",
    phone: "+91 90431 87520",
    phoneDigits: "919043187520",
    email: "info@ezhilbiomedical.com",
    address: "No.30, Bharathi Nagar, 8th Cross Street, Karuvadikuppam, Puducherry – 605008",
    addressShort: "Puducherry, India",
    rating: "5.0",
    whatsappMsg: "Hello! I'd like to enquire about your medical equipment.",
};

export const NAV_LINKS = [
    { label: "Home", id: "home" },
    { label: "About", id: "about" },
    { label: "Services", id: "services" },
    { label: "Products", id: "products" },
    { label: "Industries", id: "industries" },
    { label: "Gallery", id: "gallery" },
    { label: "Contact", id: "contact" },
];

export const SERVICES = [
    { icon: "FaStethoscope", title: "Medical Equipment Sales", desc: "Genuine, certified medical equipment from leading global brands." },
    { icon: "FaTools", title: "Biomedical Equipment Service", desc: "Comprehensive servicing for all major hospital equipment." },
    { icon: "FaCogs", title: "Installation Support", desc: "Professional on-site installation by certified engineers." },
    { icon: "FaShieldAlt", title: "Preventive Maintenance", desc: "Scheduled inspections to keep equipment running optimally." },
    { icon: "FaBalanceScale", title: "Calibration Services", desc: "Accurate, traceable calibration as per NABH guidelines." },
    { icon: "FaFileContract", title: "Annual Maintenance Contracts", desc: "AMC plans tailored to hospitals, clinics and labs." },
    { icon: "FaWrench", title: "Equipment Repair", desc: "Quick, reliable repairs with genuine OEM spare parts." },
    { icon: "FaHeadset", title: "Technical Consultation", desc: "Expert advisory for equipment selection & upgrades." },
];

const cat = (name, img) => ({ name, img });

export const PRODUCT_CATEGORIES = [
    cat("Hospital Equipment",            "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&auto=format&fit=crop"),
    cat("Surgical Instruments",          "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=800&auto=format&fit=crop"),
    cat("Patient Monitoring Systems",    "https://images.unsplash.com/photo-1666214280391-8ff5bd3c0bf0?w=800&auto=format&fit=crop"),
    cat("ECG Machines",                  "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=800&auto=format&fit=crop"),
    cat("Defibrillators",                "https://images.unsplash.com/photo-1583912267550-d6c2ac3196c0?w=800&auto=format&fit=crop"),
    cat("Ventilators",                   "https://images.unsplash.com/photo-1584467735815-f778f274e296?w=800&auto=format&fit=crop"),
    cat("Infusion Pumps",                "https://images.unsplash.com/photo-1579154204601-01588f351e67?w=800&auto=format&fit=crop"),
    cat("Syringe Pumps",                 "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=800&auto=format&fit=crop"),
    cat("Oxygen Concentrators",          "https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=800&auto=format&fit=crop"),
    cat("Nebulizers",                    "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&auto=format&fit=crop"),
    cat("Hospital Beds",                 "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=800&auto=format&fit=crop"),
    cat("ICU Beds",                      "https://images.unsplash.com/photo-1504439468489-c8920d796a29?w=800&auto=format&fit=crop"),
    cat("Examination Tables",            "https://images.unsplash.com/photo-1666214277657-e6c98a999d8c?w=800&auto=format&fit=crop"),
    cat("Wheelchairs",                   "https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?w=800&auto=format&fit=crop"),
    cat("Patient Stretchers",            "https://images.unsplash.com/photo-1551076805-e1869033e561?w=800&auto=format&fit=crop"),
    cat("Suction Machines",              "https://images.unsplash.com/photo-1583912086296-be5b665036d3?w=800&auto=format&fit=crop"),
    cat("Autoclaves",                    "https://images.unsplash.com/photo-1581595220892-b0739db3ba8c?w=800&auto=format&fit=crop"),
    cat("Sterilizers",                   "https://images.unsplash.com/photo-1583912086094-e1ab1ed75bbc?w=800&auto=format&fit=crop"),
    cat("Laboratory Equipment",          "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=800&auto=format&fit=crop"),
    cat("Diagnostic Equipment",          "https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=800&auto=format&fit=crop"),
    cat("Operation Theatre Equipment",   "https://images.unsplash.com/photo-1551076805-e1869033e561?w=800&auto=format&fit=crop"),
    cat("Emergency Equipment",           "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=800&auto=format&fit=crop"),
    cat("Medical Gas Pipeline Systems",  "https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=800&auto=format&fit=crop"),
    cat("Biomedical Spare Parts",        "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=800&auto=format&fit=crop"),
];

export const FEATURED_PRODUCTS = [
    {
        name: "Multi-Parameter Patient Monitor",
        img: "https://images.unsplash.com/photo-1666214280391-8ff5bd3c0bf0?w=900&auto=format&fit=crop",
        features: ["12.1\" Touch Display", "ECG, SpO2, NIBP, Temp", "Wireless Connectivity", "Battery Backup"]
    },
    {
        name: "ICU Ventilator",
        img: "https://images.unsplash.com/photo-1584467735815-f778f274e296?w=900&auto=format&fit=crop",
        features: ["Adult / Paediatric / Neonatal", "Multiple Ventilation Modes", "Hot-swappable Battery", "NIV Support"]
    },
    {
        name: "Defibrillator with Monitor",
        img: "https://images.unsplash.com/photo-1583912267550-d6c2ac3196c0?w=900&auto=format&fit=crop",
        features: ["Biphasic Technology", "AED + Manual Mode", "SpO2 + ECG Integrated", "Lightweight Design"]
    },
    {
        name: "Oxygen Concentrator 10L",
        img: "https://images.unsplash.com/photo-1631549916768-4119b2e5f926?w=900&auto=format&fit=crop",
        features: ["10 LPM Continuous Flow", "93% ± 3% Purity", "Low Noise Operation", "24x7 Reliable"]
    },
    {
        name: "Anesthesia Workstation",
        img: "https://images.unsplash.com/photo-1551076805-e1869033e561?w=900&auto=format&fit=crop",
        features: ["Advanced Ventilation", "Integrated Monitor", "Auto Gas Control", "OT Ready"]
    },
    {
        name: "Digital ECG Machine",
        img: "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=900&auto=format&fit=crop",
        features: ["12-Channel Recording", "Wi-Fi Sync", "Auto Interpretation", "Touch Interface"]
    },
];

export const WHY_CHOOSE = [
    { icon: "FaCheckCircle", title: "Genuine Products", desc: "Sourced directly from authorized manufacturers." },
    { icon: "FaUserMd",      title: "Expert Service Team", desc: "Certified biomedical engineers on call 24×7." },
    { icon: "FaShippingFast",title: "Fast Installation", desc: "Same-week deployment across Puducherry & Tamil Nadu." },
    { icon: "FaTags",        title: "Affordable Pricing", desc: "Best market rates with transparent quotations." },
    { icon: "FaHeadset",     title: "Customer Support", desc: "Dedicated account manager for every client." },
    { icon: "FaStar",        title: "Trusted by Healthcare Pros", desc: "5.0 Google rating from hospitals & clinics." },
];

export const INDUSTRIES = [
    { icon: "FaHospital",       name: "Hospitals" },
    { icon: "FaClinicMedical",  name: "Clinics" },
    { icon: "FaFlask",          name: "Laboratories" },
    { icon: "FaMicroscope",     name: "Diagnostic Centres" },
    { icon: "FaUniversity",     name: "Medical Colleges" },
    { icon: "FaHandHoldingMedical", name: "Healthcare Institutions" },
];

export const STATS = [
    { value: 500, suffix: "+", label: "Happy Clients" },
    { value: 2500, suffix: "+", label: "Products Delivered" },
    { value: 8500, suffix: "+", label: "Service Calls Completed" },
    { value: 12, suffix: "+", label: "Years of Experience" },
];

export const TESTIMONIALS = [
    {
        name: "Dr. Saravanan R.",
        role: "Director, Multispeciality Hospital",
        img: "https://images.pexels.com/photos/6129500/pexels-photo-6129500.jpeg?auto=compress&cs=tinysrgb&w=400",
        text: "Ezhil Biomedical's installation and service team is incredibly professional. Our ICU equipment has had zero downtime since AMC."
    },
    {
        name: "Dr. Priya Lakshmi",
        role: "Pathologist, Diagnostic Centre",
        img: "https://images.pexels.com/photos/32160037/pexels-photo-32160037.jpeg?auto=compress&cs=tinysrgb&w=400",
        text: "Their lab equipment range is unmatched in Puducherry. Calibration and after-sales support are simply best-in-class."
    },
    {
        name: "Mr. Karthik V.",
        role: "Procurement Head, Nursing Home",
        img: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400",
        text: "Transparent pricing, genuine products and same-day technical support. Ezhil is our preferred biomedical partner."
    },
    {
        name: "Dr. Anitha M.",
        role: "Consultant, Medical College",
        img: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400",
        text: "From procurement to AMC, they handle everything seamlessly. Highly recommended for any healthcare facility."
    },
];

export const BRAND_PARTNERS = [
    "Philips", "GE Healthcare", "Mindray", "Siemens", "Nihon Kohden",
    "Drager", "BPL Medical", "Schiller", "Skanray", "Olympus"
];

export const GALLERY = {
    equipment: [
        "https://images.pexels.com/photos/263402/pexels-photo-263402.jpeg?auto=compress&cs=tinysrgb&w=900",
        "https://images.pexels.com/photos/7585018/pexels-photo-7585018.jpeg?auto=compress&cs=tinysrgb&w=900",
        "https://images.pexels.com/photos/19814026/pexels-photo-19814026.jpeg?auto=compress&cs=tinysrgb&w=900",
        "https://images.pexels.com/photos/8533045/pexels-photo-8533045.jpeg?auto=compress&cs=tinysrgb&w=900",
        "https://images.pexels.com/photos/13949979/pexels-photo-13949979.jpeg?auto=compress&cs=tinysrgb&w=900",
        "https://images.pexels.com/photos/668300/pexels-photo-668300.jpeg?auto=compress&cs=tinysrgb&w=900",
    ],
    installation: [
        "https://images.unsplash.com/photo-1538108149393-fbbd81895907?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1504439468489-c8920d796a29?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1551076805-e1869033e561?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1666214277657-e6c98a999d8c?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1584467735815-f778f274e296?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1666214280391-8ff5bd3c0bf0?w=900&auto=format&fit=crop",
    ],
    service: [
        "https://images.unsplash.com/photo-1581093588401-fbb62a02f120?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=900&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1583912086094-e1ab1ed75bbc?w=900&auto=format&fit=crop",
    ],
};

export const FAQS = [
    { q: "What types of medical equipment do you supply?",
      a: "We supply a complete range of hospital, surgical, ICU, oxygen, laboratory and diagnostic equipment from leading global brands." },
    { q: "Do you provide installation and on-site training?",
      a: "Yes. Our certified biomedical engineers handle installation, commissioning and complete user training at your facility." },
    { q: "Do you offer Annual Maintenance Contracts (AMC)?",
      a: "Yes. We offer flexible Comprehensive and Non-Comprehensive AMC plans for hospitals, clinics, labs and diagnostic centres." },
    { q: "Which areas do you serve?",
      a: "We primarily serve Puducherry, Tamil Nadu and surrounding regions, with project-based service across South India." },
    { q: "Are your equipment calibrations NABH/NABL compliant?",
      a: "Absolutely. All calibrations are performed using traceable standards aligned with NABH and NABL guidelines." },
    { q: "How quickly can you respond to a service breakdown?",
      a: "Our standard response time is within 24 hours, with priority same-day response for critical care equipment under AMC." },
];
